export const Deliveries = () => (<>Hello World!</>)